module.exports = __webpack_public_path__ + "img/banner_02.129c6e34.jpg";